Game.Utils.ManageWorld = {

	init: function( layers ) {

		Game.Utils.ManageCoins.init( Game.Utils.Map.layer_properties, 3073 + 1, layers.groupElements );

		Game.Utils.ManageKeys.init( layers.groupElements );

		Game.Utils.ManageComputers.init( layers.groupElements );

		Game.Utils.ManagePlatforms.init( layers.groupElements );

		Game.Utils.ManageDoors.reset();
		Game.Utils.ManageDoors.init( 'door-horizontal', layers.groupElements );
		Game.Utils.ManageDoors.init( 'door-vertical', layers.groupElements );
		Game.Utils.ManageDoors.init( 'door', layers.groupElements );

	},

	update: function( player ) {

		Game.Utils.ManageCoins.update( player );
		Game.Utils.ManageKeys.update( player );
		Game.Utils.ManagePlatforms.update( player );
		Game.Utils.Signposts.update( player );

	},

	pre_render: function( player ) {

		Game.Utils.ManagePlatforms.pre_render( player );

	},

};
